import { MAX_CLUE_LENGTH } from '@shared/game/constants';
import { useEffect, useRef, useState } from 'preact/hooks';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Send } from './Icons';

export function ClueForm() {
  const c = useController();
  const [text, setText] = useState('');
  const [wantFocus, setWantFocus] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  const busy = c.busy.value;
  const game = c.game.value;
  const hint = c.hint.value;

  // После засчитанного хода поле очищено и снова в фокусе — можно сразу писать следующее слово
  useEffect(() => {
    if (wantFocus && !busy) {
      input.current?.focus();
      setWantFocus(false);
    }
  }, [wantFocus, busy]);

  // Новая партия — чистое поле ввода
  const gameId = game?.id;
  useEffect(() => {
    setText('');
  }, [gameId]);

  if (game && game.status !== 'play') return null;

  const submit = async () => {
    if (await c.submitClue(text)) {
      setText('');
      setWantFocus(true);
    }
  };

  return (
    <div id="playBox">
      <form
        class="cmd"
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <input
          ref={input}
          name="clue"
          value={text}
          maxLength={MAX_CLUE_LENGTH}
          placeholder={t.cluePlaceholder[c.lang.value]}
          aria-label="Подсказка"
          autocomplete="off"
          autocapitalize="off"
          spellcheck={false}
          enterkeyhint="go"
          disabled={busy || !game}
          onInput={(e) => {
            setText((e.target as HTMLInputElement).value);
            if (hint.kind === 'err') c.hint.value = { text: '', kind: '' };
          }}
        />
        <button type="submit" class="primary shine" disabled={busy || !game}>
          <span>{t.submit}</span>
          <Send />
        </button>
      </form>
      <div class={`hint ${hint.kind}`} role="status" aria-live="polite" data-testid="hint">
        {hint.text}
        {busy && (
          <span class="wave" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
        )}
      </div>
    </div>
  );
}
